
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3005_289)","fill":"#282E3E"}},[_c('path',{attrs:{"d":"M12 7.447c-1.216 0-2.36.473-3.22 1.333A4.523 4.523 0 007.448 12c0 1.216.473 2.36 1.333 3.22A4.524 4.524 0 0012 16.552c1.216 0 2.36-.473 3.22-1.333A4.524 4.524 0 0016.553 12c0-1.216-.473-2.36-1.333-3.22A4.523 4.523 0 0012 7.447zm0 6.83c-.608 0-1.18-.237-1.61-.667A2.262 2.262 0 019.723 12c0-.608.237-1.18.667-1.61A2.262 2.262 0 0112 9.723c.608 0 1.18.237 1.61.667.43.43.667 1.002.667 1.61 0 .608-.237 1.18-.667 1.61-.43.43-1.002.667-1.61.667z"}}),_c('path',{attrs:{"d":"M12 2.894c-2.719 0-5.305.856-7.479 2.478a12.628 12.628 0 00-4.469 6.287c-.07.222-.07.46 0 .682a12.627 12.627 0 004.47 6.287A12.418 12.418 0 0012 21.106c2.72 0 5.305-.857 7.48-2.478a12.456 12.456 0 004.468-6.287c.07-.222.07-.46 0-.682a12.456 12.456 0 00-4.469-6.287A12.419 12.419 0 0012 2.894zM2.338 12A10.2 10.2 0 0112 5.17 10.2 10.2 0 0121.662 12 10.2 10.2 0 0112 18.83 10.2 10.2 0 012.338 12z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3005_289"}},[_c('path',{attrs:{"fill":"#fff","transform":"matrix(1 0 0 -1 0 24)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    